import styled from 'styled-components'
import { Card, Alert, Typography } from 'antd'
import AkaButton from '../../../components/button'

const { Text } = Typography

export const StyledCard = styled(Card)`
	margin-bottom: 16px;
`

export const StyledCardTitle = styled.div`
	font-size: 16px;
	font-weight: 600;
`

export const StyledCardSubtitle = styled.div`
	font-size: 14px;
	font-weight: 400;
	color: #8c8c8c;
	margin-top: 4px;
`

export const StyledMetadataContainer = styled.div`
	margin-bottom: 16px;
`

export const StyledAlert = styled(Alert)`
	margin-bottom: 16px;
`

export const StyledTextRow = styled.div`
	margin-bottom: 12px;
	display: flex;
	align-items: center;
`

export const StyledTextLabel = styled(Text)`
	margin-right: 12px;
`

export const StyledSecondaryButton = styled(AkaButton)`
	width: auto !important;
	background-color: ${({ theme }) => theme.mainGray};
	border-color: ${({ theme }) => theme.mainGray};
	color: ${({ theme }) => theme.font};

	&:hover,
	&:focus {
		background-color: ${({ theme }) => theme.grayDarker};
		border-color: ${({ theme }) => theme.grayDarker};
		color: ${({ theme }) => theme.font};
	}

	&:active {
		background-color: ${({ theme }) => theme.grayDarker};
		border-color: ${({ theme }) => theme.grayDarker};
		color: ${({ theme }) => theme.font};
	}
`

export const StyledPrimaryButton = styled(AkaButton)`
	width: auto !important;
`

export const StyledTextRowGrid = styled(StyledTextRow)`
	display: grid;
	grid-template-columns: max-content max-content;
	column-gap: 16px;
	align-items: center;
`

export const StyledTextBlock = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 0;
`

export const StyledButtonColumn = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: 15px;
	gap: 8px;
	justify-self: start;
	align-items: flex-start;
`
